import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/binomial/cdf';
import __var_2__ from '@stdlib/stats/base/dists/binomial/ctor';
import __var_3__ from '@stdlib/stats/base/dists/binomial/entropy';
import __var_4__ from '@stdlib/stats/base/dists/binomial/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/binomial/logpmf';
import __var_6__ from '@stdlib/stats/base/dists/binomial/mean';
import __var_7__ from '@stdlib/stats/base/dists/binomial/median';
import __var_8__ from '@stdlib/stats/base/dists/binomial/mgf';
import __var_9__ from '@stdlib/stats/base/dists/binomial/mode';
import __var_10__ from '@stdlib/stats/base/dists/binomial/pmf';
import __var_11__ from '@stdlib/stats/base/dists/binomial/quantile';
import __var_12__ from '@stdlib/stats/base/dists/binomial/skewness';
import __var_13__ from '@stdlib/stats/base/dists/binomial/stdev';
import __var_14__ from '@stdlib/stats/base/dists/binomial/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace binomial
*/
var binomial = {};

/**
* @name cdf
* @memberof binomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/binomial/cdf}
*/
setReadOnly( binomial, 'cdf', __var_1__);

/**
* @name Binomial
* @memberof binomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/binomial/ctor}
*/
setReadOnly( binomial, 'Binomial', __var_2__);

/**
* @name entropy
* @memberof binomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/binomial/entropy}
*/
setReadOnly( binomial, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof binomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/binomial/kurtosis}
*/
setReadOnly( binomial, 'kurtosis', __var_4__);

/**
* @name logpmf
* @memberof binomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/binomial/logpmf}
*/
setReadOnly( binomial, 'logpmf', __var_5__);

/**
* @name mean
* @memberof binomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/binomial/mean}
*/
setReadOnly( binomial, 'mean', __var_6__);

/**
* @name median
* @memberof binomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/binomial/median}
*/
setReadOnly( binomial, 'median', __var_7__);

/**
* @name mgf
* @memberof binomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/binomial/mgf}
*/
setReadOnly( binomial, 'mgf', __var_8__);

/**
* @name mode
* @memberof binomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/binomial/mode}
*/
setReadOnly( binomial, 'mode', __var_9__);

/**
* @name pmf
* @memberof binomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/binomial/pmf}
*/
setReadOnly( binomial, 'pmf', __var_10__);

/**
* @name quantile
* @memberof binomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/binomial/quantile}
*/
setReadOnly( binomial, 'quantile', __var_11__);

/**
* @name skewness
* @memberof binomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/binomial/skewness}
*/
setReadOnly( binomial, 'skewness', __var_12__);

/**
* @name stdev
* @memberof binomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/binomial/stdev}
*/
setReadOnly( binomial, 'stdev', __var_13__);

/**
* @name variance
* @memberof binomial
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/binomial/variance}
*/
setReadOnly( binomial, 'variance', __var_14__);


// EXPORTS //
export default binomial;

export { __var_1__ as cdf, __var_2__ as Binomial, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logpmf, __var_6__ as mean, __var_7__ as median, __var_8__ as mgf, __var_9__ as mode, __var_10__ as pmf, __var_11__ as quantile, __var_12__ as skewness, __var_13__ as stdev, __var_14__ as variance};